"use strict";
import { __exports as r } from "./index.es303.js";
var u;
function m() {
  return u ? r : (u = 1, (function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "omit", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    function o(i, f) {
      const n = {};
      return Object.keys(i).forEach((e) => {
        f.includes(e) || (n[e] = i[e]);
      }), n;
    }
  })(r), r);
}
export {
  m as __require
};
//# sourceMappingURL=index.es274.js.map
